'use client';

import React from 'react';

import { type SelectableOption } from '@/types/cartCheckout/types';

import { useChangeSelectableOption } from '../hooks/useChangeSelectableOption';
import { useSubmittingForm } from '../hooks/useSubmittingForm';

type SelectableOptionsProps = {
  currentFullSizeItemId?: number;
  selectableOptions?: SelectableOption[];
};

export const ProductOptionsSelector = ({
  currentFullSizeItemId,
  selectableOptions,
}: SelectableOptionsProps) => {
  const { submittingForm } = useSubmittingForm();
  const changeSelectableOption = useChangeSelectableOption();

  return (
    <ul className="cur-flex cur-mb-0">
      {selectableOptions &&
        selectableOptions.map((selectableOption, index) => {
          return (
            <li key={selectableOption.fullSizeItemId}>
              <div
                className={`cur-border-2 cur-mr-4 cur-p-1 cur-rounded-full ${
                  selectableOption.selected
                    ? 'cur-border-solid'
                    : 'cur-border-transparent'
                }${
                  currentFullSizeItemId !== selectableOption.fullSizeItemId &&
                  !submittingForm
                    ? ' cur-cursor-pointer'
                    : ''
                }${index !== selectableOptions.length - 1 ? ' cur-mr-4' : ''}`}
                data-sentry-id="Change selectable option"
                onClick={() => changeSelectableOption(selectableOption)}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    changeSelectableOption(selectableOption);
                  }
                }}
                tabIndex={0}
              >
                <div
                  className="cur-h-6 cur-rounded-full cur-w-6"
                  style={{
                    background: selectableOption.colorHex,
                  }}
                />
              </div>
            </li>
          );
        })}
    </ul>
  );
};
